export default function About() {
  return (
    <section id="about" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">关于网红黑料</h2>
        <p className="mt-2 text-sm text-foreground-500">你的每日网红黑料情报站</p>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-6 text-left">
          <div className="bg-background-100/80 rounded-xl p-6 border border-background-200/60">
            <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4">
              <i className="ri-compass-3-line text-xl"></i>
            </div>
            <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2">我们的使命</h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              网红黑料致力于打造最全面、最及时、最可靠的网红圈黑料情报聚合平台。我们坚信信息透明是互联网健康发展的基石，通过汇总多方信源，帮助读者理性看待网红现象，让虚假人设无处遁形。
            </p>
          </div>

          <div className="bg-background-100/80 rounded-xl p-6 border border-background-200/60">
            <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-4">
              <i className="ri-team-line text-xl"></i>
            </div>
            <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2">我们的团队</h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              由资深媒体人、数据分析师和热心网友组成的编辑团队，全天候追踪网红圈最新动态。我们坚持多方核实、理性报道的原则，力求为读者提供有价值、有态度的网红黑料情报。
            </p>
          </div>
        </div>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-6 text-sm">
          <div className="flex items-center gap-2 text-foreground-600">
            <i className="ri-article-line text-accent-500 text-lg"></i>
            <span>累计发布情报 <strong className="text-foreground-900">126,847</strong> 条</span>
          </div>
          <div className="flex items-center gap-2 text-foreground-600">
            <i className="ri-user-smile-line text-accent-500 text-lg"></i>
            <span>服务吃瓜群众 <strong className="text-foreground-900">580万+</strong> 人次</span>
          </div>
          <div className="flex items-center gap-2 text-foreground-600">
            <i className="ri-calendar-check-line text-accent-500 text-lg"></i>
            <span>稳定运营 <strong className="text-foreground-900">1,289</strong> 天</span>
          </div>
        </div>
      </div>
    </section>
  );
}